import { render, staticRenderFns } from "./SpaceMediumLight2.vue?vue&type=template&id=80e44e24&"
import script from "./SpaceMediumLight2.vue?vue&type=script&lang=js&"
export * from "./SpaceMediumLight2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports